import { TablePricing } from './TablePricing';
import { Body } from './Body';
import { Header } from './Header';
import { Row } from './Row';
import { RowHeader } from './RowHeader';
import { RowSubHeader } from './RowSubHeader';
import { EmptyRow } from './EmptyRow';
import { HeaderCell } from './HeaderCell';
import { SectionHeader } from './SectionHeader';
import { Cell } from './Cell';
TablePricing.displayName = "TablePricingBase";
Header.displayName = "TablePricing.Header";
HeaderCell.displayName = "TablePricing.HeaderCell";
Body.displayName = "TablePricing.Body";
SectionHeader.displayName = "TablePricing.SectionHeader";
Row.displayName = "TablePricing.Row";
RowHeader.displayName = "TablePricing.RowHeader";
RowSubHeader.displayName = "TablePricing.RowSubHeader";
Cell.displayName = "TablePricing.Cell";
EmptyRow.displayName = "TablePricing.EmptyRow";
export { TablePricing as default, Header, HeaderCell, Body, SectionHeader, Row, RowHeader, RowSubHeader, Cell, EmptyRow };